export const FirebaseConfig = {
	"projectId": "boookit-41103",
	"appId": "1:1052511436219:web:28ecadfa8c2c282742189e",
	"databaseURL": "https://boookit-41103-default-rtdb.firebaseio.com",
	"storageBucket": "boookit-41103.firebasestorage.app",
	"apiKey": "AIzaSyDArH4dGtlDto88NYcQ1l6LqdAcHHjw_0s",
	"authDomain": "boookit-41103.firebaseapp.com",
	"messagingSenderId": "1052511436219",
	"measurementId": "G-XSD3X976L3",
	"projectNumber": "1052511436219",
	"version": "2"
};